"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ConfirmDialog;
var _react = _interopRequireDefault(require("react"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));
var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));
var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));
var _DialogContentText = _interopRequireDefault(require("@material-ui/core/DialogContentText"));
var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ConfirmDialog({
  open,
  hide,
  confirm,
  title,
  confirmText = 'OK',
  cancelText = 'Cancel',
  content
}) {
  return /*#__PURE__*/_react.default.createElement(_Dialog.default, {
    open: open,
    onBackdropClick: hide,
    onEscapeKeyDown: hide
  }, /*#__PURE__*/_react.default.createElement(_DialogTitle.default, {
    id: "alert-dialog-title"
  }, title), /*#__PURE__*/_react.default.createElement(_DialogContent.default, null, typeof content === 'string' ? /*#__PURE__*/_react.default.createElement(_DialogContentText.default, {
    id: "alert-dialog-description"
  }, content) : content), /*#__PURE__*/_react.default.createElement(_DialogActions.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: hide,
    color: "primary"
  }, cancelText), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: confirm,
    color: "primary",
    autoFocus: true
  }, confirmText)));
}
ConfirmDialog.propTypes = {
  open: _propTypes.default.bool.isRequired,
  hide: _propTypes.default.func.isRequired,
  confirm: _propTypes.default.func.isRequired,
  title: _propTypes.default.string,
  confirmText: _propTypes.default.string,
  cancelText: _propTypes.default.string,
  content: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};